import React, { useState, useEffect } from 'react';
import notesService from '../services/notesService';
import { toast } from '../utils/toast';
import './Notes.css';

const Notes = () => {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingNote, setEditingNote] = useState(null);
  const [formData, setFormData] = useState({ title: '', content: '' });

  useEffect(() => {
    loadNotes();
  }, []);

  const loadNotes = async () => {
    try {
      setLoading(true);
      const response = await notesService.getAll();
      setNotes(response.data || []);
    } catch (error) {
      console.error('Error loading notes:', error);
      toast.error('Ошибка загрузки заметок');
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setEditingNote(null);
    setFormData({ title: '', content: '' });
    setShowForm(true);
  };

  const handleEdit = (note) => {
    setEditingNote(note);
    setFormData({ title: note.title, content: note.content || '' });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить заметку?')) return;

    try {
      await notesService.delete(id);
      toast.success('Заметка удалена');
      loadNotes();
    } catch (error) {
      console.error('Error deleting note:', error);
      toast.error('Ошибка удаления заметки');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editingNote) {
        await notesService.update(editingNote.id, formData);
        toast.success('Заметка обновлена');
      } else {
        await notesService.create(formData);
        toast.success('Заметка создана');
      }
      setShowForm(false);
      loadNotes();
    } catch (error) {
      console.error('Error saving note:', error);
      toast.error('Ошибка сохранения заметки');
    }
  };

  if (loading) {
    return <div className="page"><div className="spinner"></div></div>;
  }

  return (
    <div className="page">
      <div className="notes-page-header">
        <h1>📝 Заметки</h1>
        <button className="btn btn-primary" onClick={handleCreate}>
          + Новая заметка
        </button>
      </div>

      {showForm && (
        <div className="modal-overlay" onClick={() => setShowForm(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>{editingNote ? 'Редактировать заметку' : 'Новая заметка'}</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Название</label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  required
                  className="input"
                  placeholder="Название заметки"
                />
              </div>
              <div className="form-group">
                <label>Содержание</label>
                <textarea
                  value={formData.content}
                  onChange={(e) => setFormData({ ...formData, content: e.target.value })}
                  className="input"
                  rows="10"
                  placeholder="Содержание заметки"
                />
              </div>
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>
                  Отмена
                </button>
                <button type="submit" className="btn btn-primary">
                  {editingNote ? 'Сохранить' : 'Создать'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {notes.length === 0 ? (
        <div className="card">
          <p>Нет заметок. Создайте первую заметку!</p>
        </div>
      ) : (
        <div className="notes-grid">
          {notes.map(note => (
            <div key={note.id} className="note-card">
              <div className="note-header">
                <h3>{note.title}</h3>
                <div className="note-actions">
                  <button className="btn-icon" onClick={() => handleEdit(note)} title="Редактировать">
                    ✏️
                  </button>
                  <button className="btn-icon" onClick={() => handleDelete(note.id)} title="Удалить">
                    🗑️
                  </button>
                </div>
              </div>
              <div className="note-content">
                {note.content ? (
                  <p style={{ whiteSpace: 'pre-wrap' }}>{note.content}</p>
                ) : (
                  <p style={{ color: '#999', fontStyle: 'italic' }}>Нет содержания</p>
                )}
              </div>
              <div className="note-footer">
                <small>
                  {new Date(note.updated_at).toLocaleDateString('ru-RU', { day: '2-digit', month: 'short', year: 'numeric' })}
                </small>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Notes;
